export default function ContactSection() {
  return (
    <section id="contact" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-accent-100">
            <i className="ri-mail-send-line text-2xl text-accent-600"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-[560px] mx-auto">
            你有独家线索、行业爆料或深度影评想要分享？51电影网欢迎每一位热爱电影的朋友投稿。
            无论是票房数据异常、明星幕后故事，还是电影争议事件的一手资料，我们都认真对待。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-3 mx-auto">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">爆料邮箱</h3>
              <p className="text-xs text-foreground-500">tips@51movie.com</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-3 mx-auto">
                <i className="ri-wechat-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">官方微信</h3>
              <p className="text-xs text-foreground-500">51电影网</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 mb-3 mx-auto">
                <i className="ri-edit-2-line text-lg text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">影评投稿</h3>
              <p className="text-xs text-foreground-500">review@51movie.com</p>
            </div>
          </div>

          <a
            href="#hero"
            className="inline-flex items-center px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line mr-2"></i>
            立即投稿爆料
          </a>
        </div>
      </div>
    </section>
  );
}